import { pushDataSocial } from 'lib/tracking';

export default {
  name: 'Socials',
  methods: {
    onClickSocial(brand, social) {
      pushDataSocial(brand, social);
    },
    showSocialLinks(e) {
      const clickedButton = e.target;

      this.$el
        .querySelectorAll('button')
        ?.forEach((item) => item.classList.remove('active'));
      clickedButton.classList.add('active');
    },
  },
};
